export const TEXTING_FILTER_OPTIONS = [
  { text: 'New', value: 'new' },
  { text: 'Unresolved', value: 'unresolved' },
  {
    text: 'Leslie Needs Help',
    value: 'needs_help',
    enabled: ({ flags }) => flags.leslie,
  },
];
